// src/slices/banks/thunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

//
// ================= GET ALL BANKS =================
//
export const getBanks = createAsyncThunk("bank/getAll", async (_, thunkAPI) => {
  try {
    const res = await axios.get(`${API_URL}/bank/all`);
    return res.data;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.response?.data || "Error fetching banks");
  }
});

//
// ================= GET BANK BY ID =================
//
export const getBankById = createAsyncThunk("bank/getById", async (id, thunkAPI) => {
  try {
    const res = await axios.get(`${API_URL}/bank/${id}`);
    return res.data;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.response?.data || "Error fetching bank by id");
  }
});

//
// ================= GET BANK BY SLUG =================
//
export const getBankBySlug = createAsyncThunk("bank/getBySlug", async (slug, thunkAPI) => {
  try {
    const res = await axios.get(`${API_URL}/bank/slug/${slug}`);
    return res.data;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.response?.data || "Error fetching bank by slug");
  }
});
